import React from "react";
import "./BlockedPage.sass";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { clearLocalStorage } from "../../api/sessionManagement";
import { clearUserLanguageCache } from "../../hooks/useUserLanguage.hook";
import { ROUTE_URLS } from "../../constants/consts";
import { Button } from "ui";

interface BlockedPageProps {
  text: string;
  endDate?: string | null;
}

export const BlockedPage: React.FC<BlockedPageProps> = ({ text, endDate }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  
  const formatText = (text: string): string[] => {
    return text.split("\n");
  };

  // endDate is intentionally not rendered on blocked page (per product requirement)
  void endDate;

  const handleLogout = () => {
    clearLocalStorage();
    clearUserLanguageCache();
    const browserLang = navigator.language || "en-GB";
    i18n.changeLanguage(browserLang);
    // `useBlockedAccess` listens to `storage` and checks `event.key === "sessionId"`.
    // Also, real `storage` events don't fire in the same tab, so we dispatch one manually.
    window.dispatchEvent(new StorageEvent("storage", { key: "sessionId" }));
    navigate(ROUTE_URLS.LANDING_PAGE, { replace: true });
  };

  const lines = formatText(text);

  return (
    <div className="blocked-page">
      <div className="blocked-page__content">
        {lines.map((line, index) => {
          if (!line.trim()) {
            return <br key={index} />;
          }
          
          if (index === 0 || (index > 0 && lines.slice(0, index).every(l => !l.trim()))) {
            return (
              <h1 key={index} className="blocked-page__title">
                {line}
              </h1>
            );
          }
          if (line.includes("@")) {
            const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/g;
            const parts = line.split(emailRegex);
            return (
              <p key={index} className="blocked-page__text">
                {parts.map((part, partIndex) => {
                  const isEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+$/.test(part);
                  return isEmail ? (
                    <a
                      key={partIndex}
                      href={`mailto:${part}`}
                      className="blocked-page__email"
                    >
                      {part}
                    </a>
                  ) : (
                    part
                  );
                })}
              </p>
            );
          }
          return (
            <p key={index} className="blocked-page__text">
              {line}
            </p>
          );
        })}
        <Button
          type="button"
          variant="contained"
          className="blocked-page__logout"
          onClick={handleLogout}
        >
          <Trans i18nKey="logout" />
        </Button>
      </div>
    </div>
  );
};
